module.exports = __webpack_public_path__ + "assets/img/73865506d55b2b32f9067f79cc83e4f0.png";